import { render, staticRenderFns } from "./Larger.vue?vue&type=template&id=a2c08e88&"
import script from "./Larger.vue?vue&type=script&lang=js&"
export * from "./Larger.vue?vue&type=script&lang=js&"
import style0 from "./Larger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports